module.exports = __webpack_public_path__ + "af5e6f68acaa29f258e3441cc1b7c804.pdf";